import React from "react";

// Botao vetorial de abrir menu, usado no canto superior direito.
export const MenuCombined = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 202 149"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block" }}
    preserveAspectRatio="xMaxYMin meet"
  >
    {/* ONDA CIANO — espelhada, cola no canto superior direito */}
    <path
      d="M202 0H6C6 0 8.97 81.4 50.07 122.64C91.17 163.88 202 142.42 202 142.42V0Z"
      fill="#009FE3"
    />

    {/* ONDA AZUL ESCURA */}
    <path
      d="M202 0H43.1C43.1 0 21.39 83 60.47 122C99.55 161 202 141.21 202 141.21V0Z"
      fill="#234E9E"
    />

    {/* LISTRAS HAMBÚRGUER — centradas na área azul escura (x: 98~166, y: 43~91) */}
    <path
      d="M98 91C96.87 91 95.92 90.62 95.15 89.85C94.38 89.08 94 88.13 94 87C94 85.87 94.38 84.92 95.15 84.15C95.92 83.38 96.87 83 98 83H166C167.13 83 168.08 83.38 168.85 84.15C169.62 84.92 170 85.87 170 87C170 88.13 169.62 89.08 168.85 89.85C168.08 90.62 167.13 91 166 91H98Z
      M98 71C96.87 71 95.92 70.62 95.15 69.85C94.38 69.08 94 68.13 94 67C94 65.87 94.38 64.92 95.15 64.15C95.92 63.38 96.87 63 98 63H166C167.13 63 168.08 63.38 168.85 64.15C169.62 64.92 170 65.87 170 67C170 68.13 169.62 69.08 168.85 69.85C168.08 70.62 167.13 71 166 71H98Z
      M98 51C96.87 51 95.92 50.62 95.15 49.85C94.38 49.08 94 48.13 94 47C94 45.87 94.38 44.92 95.15 44.15C95.92 43.38 96.87 43 98 43H166C167.13 43 168.08 43.38 168.85 44.15C169.62 44.92 170 45.87 170 47C170 48.13 169.62 49.08 168.85 49.85C168.08 50.62 167.13 51 166 51H98Z"
      fill="white"
    />
  </svg>
);
